import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TabPanel, a11yProps } from '../../ui';
import Frames from './frames/frames';
import Lenses from './lenses/lenses';
import Contacts from './contacts/contacts';
import Accessory from './accessories/accessory';
import Catalog from './catalog';
import Procurement from './procurement';
import DisposedFramesTab from './disposed/DisposedFramesTab';
import { useSearchParams } from 'react-router-dom';

const SUBTAB_INDICES = {
    frames: 0,
    lenses: 1,
    contacts: 2,
    accessories: 3,
    catalog: 4,
    procurement: 5,
    dispose: 6,
};

export default function Inventory() {
    const [searchParams] = useSearchParams();
    const [value, setValue] = React.useState(() => {
        const subtab = searchParams.get('subtab');
        return SUBTAB_INDICES[subtab] || 0;
    });

    React.useEffect(() => {
        const subtab = searchParams.get('subtab');
        const nextValue = SUBTAB_INDICES[subtab] || 0;
        setValue(nextValue);
    }, [searchParams]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} >
                    <Tab label="Frames" data-testid="inventory-tab-frames" {...a11yProps('inventory',0)} />
                    <Tab label="Lens" data-testid="inventory-tab-lens" {...a11yProps('inventory',1)} />
                    <Tab label="Contacts" data-testid="inventory-tab-contacts" {...a11yProps('contacts',2)} />
                    <Tab label="Accessories" data-testid="inventory-tab-accessories" {...a11yProps('inventory',3)} />
                    <Tab label="Catalog" data-testid="inventory-tab-catalog" {...a11yProps('catalog',4)} />
                    <Tab label="Procurement" data-testid="inventory-tab-procurement" {...a11yProps('procurement',5)} />
                    <Tab label="Dispose" data-testid="inventory-tab-dispose" {...a11yProps('dispose',6)} />
                </Tabs>
            </Box>
            <TabPanel idfor='Frames' value={value} index={0}>
                <Frames />
            </TabPanel>
            <TabPanel idfor='Lens' value={value} index={1}>
                <Lenses />
            </TabPanel>
            <TabPanel idfor='Contacts' value={value} index={2}>
                <Contacts />
            </TabPanel>
            <TabPanel idfor='Accessories' value={value} index={3}>
                <Accessory />
            </TabPanel>
            <TabPanel idfor='Catalog' value={value} index={4}>
                <Catalog />
            </TabPanel>
            <TabPanel idfor='Procurement' value={value} index={5}>
                <Procurement />
            </TabPanel>
            <TabPanel idfor='Dispose' value={value} index={6}>
                <DisposedFramesTab />
            </TabPanel>
        </Box>
    );
}
